import React from 'react';
import { Select } from 'antd';

import { FormInputLabel, FormInputWrapper } from './FormInput.js';

export function FormSelect({ label, ...props }) {
  return (
    <FormInputWrapper>
      <FormInputLabel>{label}</FormInputLabel>
      <Select {...props} />
    </FormInputWrapper>
  );
}
